import type { Relatorio } from './api.ts';

/**
 * A porcentagem escrita no lugar de "Rascunho" — 14/09/2026, decisão dele.
 *
 * > *"Eu ainda não entendi a utilidade do status… atualmente está como
 * > 'rascunho'. Não seria melhor ter a porcentagem?"* — Richard
 *
 * ⛔ **"Rascunho" não mudava nunca:** o botão de entregar saiu da tela em
 * 20/08/2026. Desde 14/09 o relatório é entregue junto com o caso
 * (`api/src/lib/entrega-do-relatorio.ts`), e a tela mostra o que interessa:
 * quanto está escrito, ou quando foi entregue.
 *
 * ⚠️ **A conta é `escritas / total`, que o servidor faz com a MESMA regra da
 * trava da entrega** (`lib/secao-respondida.ts`) — a mesma do "8 de 18 tópicos
 * escritos" e das plaquinhas do índice. Uma conta só.
 */
export function avancoDoRelatorio(r: Pick<Relatorio, 'situacao' | 'entregueEm' | 'escritas' | 'total'>): {
  texto: string;
  classe: string;
} {
  if (r.situacao === 'entregue') {
    return {
      texto: r.entregueEm ? `Entregue em ${r.entregueEm.split('-').reverse().join('/')}` : 'Entregue',
      classe: 's-pilula',
    };
  }
  const pct = r.total > 0 ? Math.round((r.escritas / r.total) * 100) : 0;
  return {
    texto: `${pct}% escrito`,
    classe: pct === 100 ? 's-pilula' : 's-pilula s-pilula-ouro',
  };
}
